import React, { useState } from "react";
import MyModal from "../Common/MyModal";
import { Button, Form } from "react-bootstrap";
import SmsIcon from "../../assets/icons/originator.svg2";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MyIcon from "../Common/MyIcon";
import {
  useCreateCommunicationEventMutation,
  useGetEventSolutionsQuery,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { AbsoluteLoadingIndicator } from "../Common/FullScreenLoadingIndicator";

export default function EventCreateCommunicationModal({
  eventData,
  eventSolution,
}) {
  const [createCommunication] = useCreateCommunicationEventMutation();
  const [message, setMessage] = useState();
  const [preferredChannels, setPreferredChannels] = useState([]);
  const [loading, setLoading] = useState(false);
  return (
    <MyModal
      label="Create Communication"
      buttonClassName="bg-colored-reverse px-3 btn-sm rounded-pill border-0 fw-bold text-nowrap text-white p-1"
      heading="Message"
    >
      <div className="bg-white p-3 rounded-2 my-3">
        <AbsoluteLoadingIndicator loading={loading} />
        <div className="fw-bold my-2">Do you want to create communication?</div>

        <Form.Group className="mb-3" controlId="createCommunicationTextarea">
          <Form.Label>Create Communication</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Form.Group>
      </div>
      <div className="row row-cols-2 g-3 my-2 ">
        {[
          {
            value: "sms",
            label: "SMS",
            icon: SmsIcon,
          },
          {
            value: "email",
            label: "EMAIL",
            icon: EmailIcon,
          },
          {
            value: "voice",
            label: "VOICE",
            icon: VoiceIcon,
          },
        ].map((c) => (
          <div className="col-12 col-sm-4" key={c.value}>
            <button
              type="button"
              className={`btn w-100 h-100 bg-white p-2 py-4 rounded-3 position-relative border border-2 ${
                preferredChannels.includes(c.value) ? "border-blue" : ""
              }`}
              onClick={() => {
                let newChannels = preferredChannels || [];
                if (newChannels.includes(c.value)) {
                  newChannels = newChannels.filter((ch) => ch !== c.value);
                } else {
                  newChannels.push(c.value);
                }
                setPreferredChannels(newChannels);
              }}
            >
              {preferredChannels.includes(c.value) ? (
                <FontAwesomeIcon
                  icon={faCheck}
                  className="position-absolute top-0 end-0 text-white bg-colored p-1"
                  style={{ borderBottomLeftRadius: 8 }}
                />
              ) : null}
              <div className="d-flex align-items-center ms-3">
                <MyIcon width={25} Icon={c.icon} className=" me-3" />
                <div>
                  <div className="fw-bold overflow-hidden">{c.label}</div>
                </div>
              </div>
            </button>
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-end">
        <Button
          className="bg-colored-reverse px-3 rounded-pill  border-0 btn-sm fw-bold mt-3"
          onClick={async () => {
            setLoading(true);
            await createCommunication({
              SolutionClientUuid: eventSolution.Uuid,
              ID: eventData.Reference,
              Message: message,
              PreferredChannels: preferredChannels,
            })
              .then((res) => {
                if ("data" in res) {
                  toast.success("Communication created successfully");
                }
              })
              .finally(() => {
                setMessage("");
                setPreferredChannels([]);
                setTimeout(() => {
                  setLoading(false);
                }, 500);
              });
          }}
          disabled={loading}
        >
          <div className="text-white"> Create Communication</div>
        </Button>
      </div>
    </MyModal>
  );
}
